import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenderService } from '../../../services/tender.service';
import { LoadingState } from '../../loading/loading.component';
import { AddResourceSupplierModalComponent } from '../add-resource-supplier-modal/add-resource-supplier-modal.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-resource-material-inner-tab',
  templateUrl: './resource-material-inner-tab.component.html',
  styleUrls: ['./resource-material-inner-tab.component.scss']
})
export class ResourceMaterialInnerTabComponent implements OnInit {
  @Input() tenderId: number;
  @Input() materialId: number;
  loading: LoadingState = LoadingState.NotReady;
  tenderResourceMaterialSupplierList: any = [];
  constructor(
    public dialog: MatDialog,
    private tenderService: TenderService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    var forkArray = [];
    var params = '';
    params = '?tender=' + this.tenderId + '&tender_survey_material=' + this.materialId
    forkArray.push(this.tenderService.getTenderResourceMaterialSupplierList(params))
    forkJoin(forkArray).subscribe(
      (res: any[]) => {
       // console.log(res)
        for (var i = 0; i < res.length; i++) {
          if (i == 0) {
            this.tenderResourceMaterialSupplierList = res[i]['result'];
          }
        }
        this.loading = LoadingState.Ready
      },
      error => {
        console.log(error)
        this.loading = LoadingState.Ready
      }
    )
  }



  openResourceSupplierModal() {
    let dialogRef = this.dialog.open(AddResourceSupplierModalComponent, {
      width: '525px',
      data: { tenderId: this.tenderId, tender_survey_material: this.materialId }
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log(result)
      if (result['data'] != undefined) {
        this.tenderResourceMaterialSupplierList.push(result['data'])
      }
    })
  }

  editResourceSupplier(i) {
    let dialogRef = this.dialog.open(AddResourceSupplierModalComponent, {
      width: '525px',
      data: { tenderId: this.tenderId, tender_survey_material: this.materialId, supplierDetails: this.tenderResourceMaterialSupplierList[i] }
    });
    dialogRef.afterClosed().subscribe(result => {
     // console.log(result)
      if (result['data'] != undefined) {
        this.tenderResourceMaterialSupplierList[i] = result['data']
      }
    })
  }

  deleteResourceSupplier(i) {
    this.loading = LoadingState.Processing;
    this.tenderService.deleteTenderResourceMaterialSupplier(this.tenderResourceMaterialSupplierList[i]['id']).subscribe(
      res => {
        //console.log(res)
        this.tenderResourceMaterialSupplierList.splice(i, 1)
        this.loading = LoadingState.Ready;
      },
      error => {
        console.log(error)
        this.loading = LoadingState.Ready;
      }
    )
  }

}
